import { dndPromotion, getAwardSrcById } from "../main/setup/js/_promotion";

$(document).on(
  "taydu2_cuuthienhuyennu_vongquay rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    const randomInRange = (start, end) => {
      return Math.floor(Math.random() * (end - start + 1) + start);
    };

    // ===== SWIPER THANH MỐC TÍCH LŨY =====
    // PC (landscape, width >= 701) hiện đủ 5 mốc như layout cũ; mobile portrait (<701) hiện 3/view + nút ‹›.
    // Init NẰM TRONG handler "...vongquay rendered" (chạy lúc window load) → Swiper global từ CDN đã sẵn sàng.
    // Dùng $.fn.initSwiper của project (auto-wire nav theo id "milestoneSwiper").
    if ($("#milestoneSwiper").length > 0) {
      // Tooltip mocqua vốn nằm TRONG slide nên bị Swiper (overflow:hidden mặc định) cắt mất khi trồi lên
      // (top:-190px). Không đổi HTML gốc — dời tooltip ra ngoài (sibling của #milestoneSwiper, không bị
      // clip) NGAY LÚC RUNTIME bằng JS, rồi tự tính vị trí + tự bật/tắt theo hover thay cho CSS :hover cũ.
      var $milestoneRoot = $this.find(".group__tichluy--item");
      var $milestoneSlides = $this.find(".group__tichluy--item--child--item");
      var $tooltips = $this
        .find(".group__tichluy--item--child--item .tooltip")
        .detach()
        .appendTo($milestoneRoot);

      var milestoneTranslate = 0;

      function positionMilestoneTooltip($slide, $tooltip) {
        var swiperRootEl = $this.find("#milestoneSwiper")[0];
        var base =
          swiperRootEl.offsetLeft + $slide[0].offsetLeft + milestoneTranslate;
        $tooltip[0].style.setProperty("--tooltip-base-left", base + "px");
      }

      $milestoneSlides.each(function (idx) {
        var $slide = $(this);
        var $tooltip = $tooltips.eq(idx);

        $slide.on("mouseenter", function () {
          positionMilestoneTooltip($slide, $tooltip);
          $tooltip.addClass("show");
        });
        $slide.on("mouseleave", function () {
          $tooltip.removeClass("show");
        });
      });

      // Mốc ĐÃ NHẬN/NHẬN tự suy theo SỐ đang hiển thị ở "Đã tích lũy" (không phụ thuộc class BE gắn) —
      // BE chỉ cần đổi con số trong .point_tichluy span, hàm này tự so ngưỡng rồi bật/tắt .received.
      var TICHLUY_MILESTONES = [3, 5, 10, 15, 20];

      function renderTichluyMilestones() {
        var currentPoint =
          parseInt($this.find(".point_tichluy span").text(), 10) || 0;
        $milestoneSlides.each(function (idx) {
          var threshold = TICHLUY_MILESTONES[idx];
          if (threshold === undefined) return;
          $(this)
            .find(".btn__gift")
            .toggleClass("received", currentPoint >= threshold);
        });
      }

      renderTichluyMilestones();
      window.renderTichluyMilestones = renderTichluyMilestones;

      $("#milestoneSwiper").initSwiper({
        swiperOptions: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
          watchOverflow: true, // PC đủ 5 slide → swiper tự khoá kéo + ẩn nav
          autoplay: false,
          navigation: {
            nextEl: ".swiper-button-next--milestoneSwiper",
            prevEl: ".swiper-button-prev--milestoneSwiper",
          },
          breakpoints: {
            769: {
              slidesPerView: "auto",
              spaceBetween: 55,
            },
          },
          on: {
            setTranslate: function (swiper, translate) {
              milestoneTranslate = translate;
              var $activeTooltip = $tooltips.filter(".show");
              if ($activeTooltip.length) {
                var idx = $tooltips.index($activeTooltip);
                positionMilestoneTooltip(
                  $milestoneSlides.eq(idx),
                  $activeTooltip,
                );
              }
            },
          },
        },
      });
    }

    if ($(".action").length > 0) {
      dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        wait: 0,
        callback: function () {
          window.renderTurnProgress && window.renderTurnProgress();
          window.renderTichluyMilestones && window.renderTichluyMilestones();
        },
        animBefore: function () {
          $("#action").addClass("off");
        },
        animResult: function (listPrize) {
          if (typeof LuckyDrawExchangeModule !== "undefined") {
            LuckyDrawExchangeModule.fetchViewData();
          }
          $(".voso").addClass("active");
          setTimeout(function () {
            $(".voso").removeClass("active");
          }, 1500);

          setTimeout(function () {
            $("#popup_reward").addClass("active");
            $("#action").removeClass("off");
          }, 1500);
        },
        animWait: function () {
          $("#action").addClass("off");
        },
      });

      window["getAwardSrcById"] = getAwardSrcById;
    }
  },
);
